"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAccordionItemContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useAccordionItemContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useAccordionItemContextValues_unstable(state) {
    // eslint-disable-next-line deprecation/deprecation
    const { disabled, open, value, onHeaderClick } = state;
    const accordionItem = _react.useMemo(()=>({
            disabled,
            open,
            value,
            onHeaderClick
        }), [
        disabled,
        open,
        value,
        onHeaderClick
    ]);
    return {
        accordionItem
    };
}
